// ==========================================================================
// components/Brand.tsx — emblem + wordmark (FF-022, 9 Oct 2026)
// The crest takes the theme colour (Emblem, FF-058).
// ==========================================================================
import Emblem from "./Emblem";

export function Brand({ size = "lg" }: { size?: "lg" | "sm" }) {
  if (size === "sm") {
    return (
      <div className="flex items-center gap-2">
        <Emblem className="h-8 w-8" />
        <span className="font-heading font-semibold text-primary tracking-[0.15em]">O’SULLIVAN</span>
      </div>
    );
  }
  return (
    <header className="flex flex-col items-center text-center">
      <Emblem className="w-40 h-auto" />
      <h1 className="font-heading font-semibold text-primary text-3xl tracking-[0.15em] mt-2">O’SULLIVAN</h1>
      <p className="flex items-center gap-3 text-accent text-xs font-semibold tracking-[0.35em] mt-1">
        <span className="h-px w-10 bg-accent/60" />FAMILY APP<span className="h-px w-10 bg-accent/60" />
      </p>
    </header>
  );
}
